<template>
  <div class="dashboard-content">
    <div class="main-container">
      <h2 class="page-title">대시보드</h2>

      <!-- 로딩 상태 -->
      <div v-if="loading" class="loading-state">
        <p>데이터를 불러오는 중...</p>
      </div>

      <!-- 대시보드 카드 -->
      <div v-else class="dashboard-cards">
        <div class="stat-card">
          <div class="stat-label">누적 Zone 4+</div>
          <div class="stat-value purple">
            {{ totalHours }}<span class="unit">시간</span> {{ totalMinutes
            }}<span class="unit">분</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-label">이번 주 Zone 4+</div>
          <div class="stat-value orange">
            <template v-if="weeklyHours > 0">
              {{ weeklyHours }}<span class="unit">시간</span>
            </template>
            {{ weeklyMinutes }}<span class="unit">분</span>
          </div>
        </div>

        <div class="stat-card sticker-card">
          <div class="stat-label">다음 스티커까지</div>
          <div class="stat-value green">
            {{ minutesToSticker }}<span class="unit">분 남음</span>
          </div>
          <div class="progress-bar">
            <div
              class="progress-fill"
              :style="{ width: stickerProgress + '%' }"
            ></div>
          </div>
          <div class="progress-info">
            <span>{{ 60 - minutesToSticker }}분 완료</span>
            <span>60분</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiJson } from "@/lib/api";

export default {
  name: "DashboardView",
  data() {
    return {
      loading: true,
      totalZone4Plus: 0,
      weeklyZone4Plus: 0,
      minutesToSticker: 0,
    };
  },
  computed: {
    totalHours() {
      return Math.floor(this.totalZone4Plus / 60);
    },
    totalMinutes() {
      return Math.round(this.totalZone4Plus % 60);
    },
    weeklyHours() {
      return Math.floor(this.weeklyZone4Plus / 60);
    },
    weeklyMinutes() {
      return Math.round(this.weeklyZone4Plus % 60);
    },
    stickerProgress() {
      return Math.round(((60 - this.minutesToSticker) / 60) * 100);
    },
  },
  created() {
    this.loadDashboard();
  },
  methods: {
    async loadDashboard() {
      try {
        this.loading = true;
        const data = await apiJson("/v1/me/dashboard");
        this.totalZone4Plus = data.totalZone4Plus;
        this.weeklyZone4Plus = data.weeklyZone4Plus;
        this.minutesToSticker = Math.round(data.minutesToSticker);
      } catch (e) {
        console.error("대시보드 로딩 실패:", e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-content {
  width: 100%;
}

.main-container {
  max-width: 800px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #fff;
}

.loading-state {
  text-align: center;
  padding: 40px 0;
  color: #8e8e8e;
}

.dashboard-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-card {
  background: #0a0a0a;
  border: 1px solid rgba(114, 114, 114, 0.2);
  border-radius: 5px;
  padding: 16px;
}

.stat-label {
  color: #fff;
  font-size: 18px;
  margin-bottom: 12px;
}

.stat-value {
  font-size: 30px;
  font-weight: 400;
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.stat-value.purple {
  color: #8b5cf6;
}

.stat-value.orange {
  color: #f59e0c;
}

.stat-value.green {
  color: #22c55e;
}

.stat-value .unit {
  font-size: 16px;
  color: #8e8e8e;
  margin-bottom: 4px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  margin-top: 16px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #4ade80);
  border-radius: 6px;
  transition: width 0.6s ease;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 13px;
  color: #8e8e8e;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .stat-label {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-value .unit {
    font-size: 12px;
  }
}
</style>
